// extracted by mini-css-extract-plugin
export default {"form--secondary":"MRPsC","form-layout":"naROr"};